'use strict';

const React = require( 'react' );
const propTypes = require('prop-types');
const getAirportInfo = require( './getAirportInfo' );
const { string } = propTypes;
const createReactClass = require('create-react-class');

const Breadcrumb = createReactClass({
  propTypes: {
    pageName: string
  },

  convertPageToText( page ) {
    return page.replace( /-/g, ' ' ).replace( /\b\w/g, l => l.toUpperCase( ));
  },

  convertPageToCrumbs( ) {
    const { pageName } = this.props;
    if ( !pageName ) return null;
    let crumbs = pageName.split( '.' )[0].split( '/' );

    if ( !pageName.match( 'hotels-with-parking' ) && pageName.match( 'hotel' ) && pageName !== 'airport-hotels' ) {
      crumbs = [ 'airport-hotels', ...crumbs];
    }
    if ( pageName.match( 'parking' ) && pageName !== 'airport-parking' ) {
      crumbs = [ 'airport-parking', ...crumbs];
    }
    if ( pageName.match( 'hotels-with-parking' ) && pageName !== 'airport-hotels-with-parking' ) {
      crumbs = [ 'airport-hotels-with-parking', crumbs.slice(-1)[0]];
    }
    return this.makeCrumbs( crumbs.map( page => {
      const text = this.convertPageToText( page );
      return {
        text,
        page
      };
    }));
  },

  makeCrumbs( crumbs ) {
    let trail = '';
    const lastPage = crumbs[ Object.keys( crumbs ).pop( ) ].page;
    return Object.keys( crumbs ).map( ( crumbItem, key ) => {
      const crumb = crumbs[crumbItem];
      // page your on
      if ( !crumb.page || crumb.page === lastPage ) return ( <li className="active" key={ key }>{ crumb.text }</li> );
      trail += '/' + crumb.page;
      let url = trail;
      const location = getAirportInfo( url );
      if ( location && crumb.text.toLowerCase( ) === location.pattern.toLowerCase( ) ) {
        url = '/' + crumb.text.toLowerCase( );
        if ( trail.match( 'port-parking' ) && !trail.match( 'airport-parking' )) url += '-port-parking';
        if ( trail.match( 'port-hotels' ) && !trail.match( 'airport-hotels' )) url += '-port-hotels';
        if ( trail.match( 'airport-parking' )) url += '-airport-parking';
        if ( !trail.match( 'airport-hotels-with-parking' ) && trail.match( 'aiprort-hotels' )) url += '-airport-hotels';
        if ( trail.match( 'airport-hotels-with-parking' ) ) url += '-airport-hotels-with-parking';
        if ( trail.match( 'airport-lounges' )) url += '-airport-lounges';
      }
      return (
        <li key={ key }>
          <a href={ url + '.html' } title={ crumb.text }>{ crumb.text }</a>
        </li>
      );
    });
  },

  render: function() {
    const crumbs = this.convertPageToCrumbs( );
    return (
      <ul className="breadcrumb">
        <li><strong>You are here:</strong></li>
        <li>
          <a href="/"><i className="fa fa-home"></i>Home</a>
        </li>
        { crumbs }
      </ul>
    );
  }
});

module.exports = Breadcrumb;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/breadcrumb.jsx